import { CALL_API } from '../middleware/ApiMiddleware';

export const FETCH_BROADCASTS_REQUEST = 'FETCH_BROADCASTS_REQUEST';
export const FETCH_BROADCASTS_SUCCESS = 'FETCH_BROADCASTS_SUCCESS';
export const FETCH_BROADCASTS_FAILURE = 'FETCH_BROADCASTS_FAILURE';
export const SEND_BROADCAST_REQUEST = 'SEND_BROADCAST_REQUEST';
export const SEND_BROADCAST_SUCCESS = 'SEND_BROADCAST_SUCCESS';
export const SEND_BROADCAST_FAILURE = 'SEND_BROADCAST_FAILURE';
export const FETCH_BROADCAST_RECIPIENT_COUNT_REQUEST = 'FETCH_BROADCAST_RECIPIENT_COUNT_REQUEST';
export const FETCH_BROADCAST_RECIPIENT_COUNT_SUCCESS = 'FETCH_BROADCAST_RECIPIENT_COUNT_SUCCESS';
export const FETCH_BROADCAST_RECIPIENT_COUNT_FAILURE = 'FETCH_BROADCAST_RECIPIENT_COUNT_FAILURE';

export const fetchBroadcasts = (agencyId: number, limit = 50) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/broadcasts?limit=${limit}`,
    method: 'get',
    authenticated: true,
    types: [FETCH_BROADCASTS_REQUEST, FETCH_BROADCASTS_SUCCESS, FETCH_BROADCASTS_FAILURE],
  },
});

export const sendBroadcast = (agencyId: number, title: string, body: string) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/broadcasts`,
    method: 'post',
    authenticated: true,
    body: { title, body },
    hideDefaultAlert: true,
    types: [SEND_BROADCAST_REQUEST, SEND_BROADCAST_SUCCESS, SEND_BROADCAST_FAILURE],
  },
});

export const fetchBroadcastRecipientCount = (agencyId: number) => ({
  [CALL_API]: {
    endpoint: `agencies/${agencyId}/devices/count`,
    method: 'get',
    authenticated: true,
    hideDefaultAlert: true,
    types: [
      FETCH_BROADCAST_RECIPIENT_COUNT_REQUEST,
      FETCH_BROADCAST_RECIPIENT_COUNT_SUCCESS,
      FETCH_BROADCAST_RECIPIENT_COUNT_FAILURE,
    ],
  },
});
